import apiClient from './apiClient';

// Use the main apiClient which has proper error handling
const api = apiClient;

const fullFinalSettlementApi = {
  // Get all settlements
  getSettlements: async (params = {}) => {
    try {
      const response = await api.get('/payroll/settlements', { params });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get settlement by ID
  getSettlementById: async (id) => {
    try {
      const response = await api.get(`/payroll/settlements/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Create new settlement
  createSettlement: async (settlementData) => {
    try {
      const response = await api.post('/payroll/settlements', settlementData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Update settlement
  updateSettlement: async (id, settlementData) => {
    try {
      const response = await api.put(`/payroll/settlements/${id}`, settlementData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Delete settlement
  deleteSettlement: async (id) => {
    try {
      const response = await api.delete(`/payroll/settlements/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Approve settlement
  approveSettlement: async (id) => {
    try {
      const response = await api.post(`/payroll/settlements/${id}/approve`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Process settlement payment
  processSettlement: async (id) => {
    try {
      const response = await api.post(`/payroll/settlements/${id}/process`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Download settlement PDF
  downloadSettlement: async (id) => {
    try {
      const response = await api.get(`/payroll/settlements/${id}/download`);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};

export default fullFinalSettlementApi;

